// src/utils/rtlHandler.jsx
// Robust RTL/LTR handling with SSR guards and helper classes.

const RTL_BASES = new Set([
  "ar", "he", "iw", "fa", "ur", "ps", "dv", "syr", "ug", "yi", "ks", "sd", "nqo",
  "ckb", "azb"
]);

function normalizeLang(tag) {
  const raw = String(tag || "").trim();
  if (!raw) return { tag: "en", base: "en" };
  const base = raw.split("-")[0].toLowerCase();
  return { tag: raw, base };
}

/** Heuristic: RTL if base is RTL or script subtag is 'Arab'. */
export function isRTL(lang) {
  const { tag, base } = normalizeLang(lang);
  if (RTL_BASES.has(base)) return true;
  return /-Arab\b/i.test(tag);
}

/** Apply dir+lang on <html>, and toggle .rtl/.ltr on html & body. */
export function setHtmlDirection(lang) {
  if (typeof document === "undefined") return; // SSR/preview guard

  const dir = isRTL(lang) ? "rtl" : "ltr";
  const { tag } = normalizeLang(lang);

  const html = document.documentElement;
  const body = document.body;

  try {
    html.setAttribute("dir", dir);
    html.setAttribute("lang", tag);
  } catch {}

  const add = (el, cls) => el && !el.classList.contains(cls) && el.classList.add(cls);
  const remove = (el, cls) => el && el.classList.contains(cls) && el.classList.remove(cls);

  // keep classes mutually exclusive
  ["rtl", "ltr"].forEach((c) => {
    if (c !== dir) {
      remove(html, c);
      remove(body, c);
    }
  });
  add(html, dir);
  add(body, dir);
}

export default setHtmlDirection;
